import { Action } from 'redux';
import { FUTURE } from 'src/modules/common/types/Future';
import { PROJECT_LIST_CLONE } from 'src/modules/project-list/actions/ProjectListActions';
import { ProjectListState } from 'src/modules/project-list/types/ProjectListState';

export function projectListClonningReducer(state: ProjectListState, action: Action): ProjectListState {
  if (PROJECT_LIST_CLONE.isPending(action)) {
    return {
      ...state,
      clonning: {
        project: action.meta,
        status: FUTURE.pending(),
      },
    };
  }
  if (PROJECT_LIST_CLONE.isSuccess(action)) {
    return {
      ...state,
      clonning: {
        project: action.meta,
        status: FUTURE.success(undefined),
      },
    };
  }
  if (PROJECT_LIST_CLONE.isFailure(action)) {
    return {
      ...state,
      clonning: {
        project: action.meta,
        status: FUTURE.failure(action.data),
      },
    };
  }

  return state;
}
